import { useTaskGridPreferencesQuery, useUpdateTaskGridPreferencesMutation } from "./queries";
import type { DensityMode } from "../types";

/**
 * Density preference for the matrix — "comfortable" vs "compact". Backed by
 * the server-side task_grid_preferences row so the preference follows the
 * user across browsers.
 */
export default function useDensityMode(): {
  density: DensityMode;
  setDensity: (next: DensityMode) => void;
} {
  const prefsQuery = useTaskGridPreferencesQuery();
  const updatePrefs = useUpdateTaskGridPreferencesMutation();

  const density: DensityMode = prefsQuery.data?.density ?? "comfortable";

  const setDensity = (next: DensityMode) => {
    if (next === density) return;
    updatePrefs.mutate({ density: next });
  };

  return { density, setDensity };
}
